<template>
	<div class="game_list">
		<el-card class="box-card">
			<el-form :inline="true" :model="formData" ref='loginRef' @keydown.enter.native="searchGameHandle">
				<el-form-item prop="gameName" label="游戏名称 :">
					<el-input v-model="formData.gameName" placeholder="请输入游戏名称"></el-input>
				</el-form-item>
				<el-form-item style="text-align: center;">
					<el-button type="primary" @click="searchGameHandle">搜索</el-button>
				</el-form-item>
			</el-form>
			<el-button type="primary" icon='el-icon-plus' @click='dialogCreate=true'>新增</el-button>
			<!-- 列表页 -->
			<el-table :data="gameList" border style="width: 100%;margin-bottom: 10px;">
				<el-table-column prop="gameId" label="游戏ID" width="300">
				</el-table-column>
				<el-table-column prop="gameName" label="游戏名称" width="300">
				</el-table-column>
				<el-table-column prop="gamePlate" label="游戏平台" width="300">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="proDelete(scope.row.id)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 项目翻页管理 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="page" :page-sizes="[5, 10, 20, 30]" :page-size="size"
					layout="total, sizes, prev, pager, next, jumper" :total="count">
			</el-pagination>
		</el-card>

		<!-- 创建账号弹框 -->
		<el-dialog :visible.sync="dialogCreate" :rules="caseRules" ref='createRef' class="createGame">
			<template slot='title'>
				<div style="text-align: center;width: 100%;font-size: 24px;">新增游戏</div>
			</template>
			<el-form :model="newGame" label-width="80px" size='mini' :rules="caseRules" ref='createRef'>
				<el-form-item label="游戏ID" prop="gameId">
					<el-input v-model="newGame.gameId"></el-input>
				</el-form-item>
				<el-form-item label="游戏名称" prop="gameName">
					<el-input v-model="newGame.gameName"></el-input>
				</el-form-item>
				<el-form-item prop="gamePlate" label="游戏平台">
					<el-select v-model="newGame.gamePlate" placeholder="请选择游戏平台">
						<el-option
						v-for="item in gamePlateList"
						:key="item"
						:label="item"
						:value="item">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="create">提交</el-button>
			</div>
		</el-dialog>
	</div>
</template>
 
<script>
import manageApi from "../api/manage"
	export default {
		data() {
			return {
				gameList: [],
				// 当前选择的页码
				page: 1,
				// 数据总数
				count: 0,
				//每页的数据量
				size: 10,
				formData: {
					gameName: ''
				},
				gamePlateList: [], //游戏平台列表
				//创建
				dialogCreate: false,
				newGame: {
					gameId: '',
					gameName: '',
					gamePlate: ''
				},
				// 校验规则
				caseRules: {
					gameId: [{
						required: true,
						message: '游戏ID不能为空',
						trigger: 'blur'
					}],
					gameName: [{
						required: true,
						message: '游戏名称不能为空',
						trigger: 'blur'
					}],
					gamePlate: [{
						required: true,
						message: '游戏平台不能为空',
						trigger: 'blur'
					}]
				}
 
			}
		},
		  //页面加载时执行
		created() {
			//获取游戏平台列表
			manageApi.listGamePlate().then((response) => {
			this.gamePlateList = response.data.gamePlateList
			})
		},
		methods: {
			close() {
				this.dialogCreate = false
				this.newGame.gameId = ''
				this.newGame.gameName = ''
				this.newGame.gamePlate = ''
			},
			searchGameHandle() {
				this.getList()
			},
			create() {
				manageApi.addGame(this.newGame).then((res)=>{
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: res.data.message,
							duration: 1000
						});
						// 更新页面的数据
						this.getList()
						// 关闭弹框
						this.dialogCreate = false
						this.close()
					} else {
						this.$message({
						message: res.data.message,
						type: 'error',
						duration: 1000
						});
					}
				})
			},
			async proDelete(id) {
				console.log('当前删除的数据id为：', id)
				manageApi.deleteGame(id).then((res) => {
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: res.data.message,
							duration: 1000
						});
						// 更新页面的数据
						this.getList()
					} else {
						this.$message({
						message: res.data.message,
						type: 'error',
						duration: 1000
						});
					}
				})
			},
			// 获取列表
			async getList() {
				manageApi.listGame(this.formData,this.size,this.page).then((res) => {
					if (res.code === 200) {
						this.gameList = res.data.gamePage.records
						// 保存数据总数
						this.count = res.data.gamePage.total
					} else {
						this.$message({
						message: res.data.message,
						type: 'error',
						duration: 1000
						});
					}
				})
			},
			// 处理每页数量大小变化的方法
			handleSizeChange(size) {
			this.size = size
			this.page = 1
			this.getList()
			},
			// 处理页码变化的方法
			handleCurrentChange(page) {
				this.page = page
				this.getList()
			}
		},
 
		// vue实例数据挂载之后，出触发这个钩子函数
		mounted() {
			this.getList()
		}
 
	}
</script>
 
<style scoped>
.createGame {
	width: 60%;
	margin: 0 auto;
}
</style>